import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {BSModalContext} from 'ngx-modialog/plugins/bootstrap';
import {Modal, overlayConfigFactory} from 'ngx-modialog';
import {CreditCardProvider, OrganizationParameter} from '../../../utils/objects/organization-parameter';
import {ApiService} from '../../../utils/services/api.service';
import {CreditCardInfoComponent} from '../credit-card-info/credit-card-info.component';

@Component({
  selector: 'app-credit-card',
  templateUrl: './credit-card.component.html',
  styleUrls: ['./credit-card.component.css']
})

export class CreditCardComponent implements OnInit {

  public creditCardProviders: Array<CreditCardProvider> = [];
  public parameter = [];
  public organizationID;

  constructor(public modal: Modal,
              private activatedRoute: ActivatedRoute,
              private apiService: ApiService) {
  }

  ngOnInit() {
    this.organizationID = this.activatedRoute.snapshot.parent.params.id;

    this.apiService.getOrganizationParameters(this.organizationID).subscribe(
      response => {
        this.parameter = response['data'].rows;
        this.parameter.forEach((organizationParameter: OrganizationParameter) => {
          switch (organizationParameter.type) {
            case 'PaymentGateway':

              let isProviderExists = false;
              this.creditCardProviders.forEach((creditCardProvider: CreditCardProvider) => {
                if (creditCardProvider.provider === organizationParameter.context) {
                  isProviderExists = true;
                  creditCardProvider[organizationParameter.key] = organizationParameter;
                }
              });

              if (!isProviderExists) {
                let creditCardProvider = new CreditCardProvider();
                creditCardProvider.provider = organizationParameter.context;
                creditCardProvider[organizationParameter.key] = organizationParameter;
                this.creditCardProviders.push(creditCardProvider);
              }
              break;
          }
        });
      }, error => {

      }
    );
  }

  addFlightProvider() {
    let dialogRef = this.modal.open(
      CreditCardInfoComponent,
      overlayConfigFactory({size: 'lg', organizationID: this.organizationID}, BSModalContext));

    dialogRef.result.then((result) => {
      if (result) {
        result.forEach((response) => {
          switch (response.data.type) {
            case 'PaymentGateway':

              let isProviderExists = false;
              this.creditCardProviders.forEach((creditCardProvider: CreditCardProvider) => {
                if (creditCardProvider.provider === response.data.context) {
                  isProviderExists = true;
                  creditCardProvider[response.data.key] = response.data;
                }
              });

              if (!isProviderExists) {
                let creditCardProvider = new CreditCardProvider();
                creditCardProvider.provider = response.data.context;
                creditCardProvider[response.data.key] = response.data;
                this.creditCardProviders.push(creditCardProvider);
              }
              break;
          }
        });
      }
    });
  }

  openFlightProviderDetail(flightProvider) {
    let dialogRef = this.modal.open(
      CreditCardInfoComponent,
      overlayConfigFactory({
        size: 'lg',
        organizationID: this.organizationID,
        flightProvider: flightProvider
      }, BSModalContext));

    dialogRef.result.then((result) => {

    });
  }
}



// WEBPACK FOOTER //
// C:/Biziclick/bizisystem/src/app/main/frames/credit-card/credit-card.component.ts